import { isTabHidden } from "pages/DevelopWorkspace/contexts/DocumentsContext/helpers/tabGroupOrdering";
import { DocumentsState } from "pages/DevelopWorkspace/workspace.types";

/*
The next/previous tab controls only iterate over uncollapsed grouped tabs and 
ungrouped tabs and DO NOT expand collapsed groups.
The iteration is cyclic (wrap-around).
 */
export const getSiblingDocumentId = (
  state: DocumentsState,
  step: 1 | -1
): string | null => {
  const shown = state.documents.filter(
    document => !isTabHidden(state.tabGroups, document)
  );

  const currentIndex = shown.findIndex(
    document => document.id === state.activeDocumentId
  );

  if (currentIndex === -1 || shown.length < 2) {
    return null;
  }

  return shown[(currentIndex + step + shown.length) % shown.length].id;
};
